import {
  SET_STORE_DETAIL,
  SET_USER_PROFILE,
  SET_GUEST_USER_PROFILE,
  SET_COUNTRIES_INFO,
  SET_STORES_INFO,
  SET_GUEST_CART,
  SET_STORE
} from './action-types';

const INITIAL_STATE = {
  storeDetail: {},
  profile: {},
  countries:[],
  storesList: [],
  guestCartList: [],
  store: {}
};

export default function authReducer(state = INITIAL_STATE, action) {
  if (!action || !action.type) {
    return state;
  }
  switch (action.type) {
    case SET_STORE_DETAIL:
      return Object.assign({}, state, {
        storeDetail: action.data
      });
    case SET_USER_PROFILE:
      return Object.assign({}, state, {
        profile: action.data
      });
      case SET_GUEST_USER_PROFILE:
        return Object.assign({}, state, {
          guestprofile: action.data
        });      
    case SET_COUNTRIES_INFO:
      return Object.assign({}, state, {
        countries: action.data
      });
    case SET_STORES_INFO:
      return Object.assign({}, state, {
        storesList: action.data
      });
    case SET_GUEST_CART:
      return Object.assign({}, state, {
        guestCartList: action.data
      });
    case SET_STORE:
        return Object.assign({}, state, {
          store: action.data
        });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/reducer.js